export function numberWithThousandSeparator(x: number) {
	if (x === undefined || x === null) return '-';

	var parts = x.toString().split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return parts.join('.');
}

export function fixedDecimal(x: number) {
	return +x.toFixed(10);
}

export function displayRating(
	number: string | number = 0,
	fixedLength: number = 2,
): string | number {
	const numberTarget = parseFloat(`${number}`) || 0;
	if (numberTarget && numberTarget > 0) {
		const fixed: number | string = numberTarget.toFixed(fixedLength);
		return Number(fixed) === number ? Number(fixed) : fixed;
	}
	return number;
}

export const formatNumber = (amount: number, decimalPlace = 2, symbol = '') => {
	if (Number(amount) === 0) return '0';

	let amountTemp: string | number = amount;
	const index = String(amount).indexOf('.');
	if (index === -1) amountTemp = Number(amount).toFixed(2);

	let roundAmount = amountTemp.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	let rindex = roundAmount.indexOf('.');
	let hasDecimal = decimalPlace !== 0 ? 1 : 0;

	return roundAmount.slice(0, rindex + hasDecimal + decimalPlace) + symbol;
};
